import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button, Divider } from 'base-ui'

export const DirectContactPostCardDialogContent: FC<{
  onClick: () => void
}> = ({ onClick }) => {
  return (
    <>
      <div className="flex flex-col gap-2 text-center tablet:px-40">
        <h3 className="text-xl font-medium">
          <FormattedMessage id="contact.postalAddress.heading" />
        </h3>

        <div className="my-3 flex flex-col gap-3">
          <p>
            <FormattedMessage id="contact.postalAddress.firstAddress.address" />
          </p>
          <p>
            <FormattedMessage id="contact.postalAddress.firstAddress.poBox" />
          </p>
          <p>
            <FormattedMessage id="contact.postalAddress.firstAddress.title" />
          </p>
        </div>
        <Divider className="text-dark-primary-strong">
          <FormattedMessage id="contact.general.label.or" />
        </Divider>
        <div className="my-3 flex flex-col gap-3">
          <p>
            <FormattedMessage id="contact.postalAddress.secondAddress.address" />
          </p>
          <p>
            <FormattedMessage id="contact.postalAddress.secondAddress.title" />
          </p>
        </div>
      </div>
      <Button className="mt-4 w-full" color="secondary" onClick={onClick}>
        <FormattedMessage id="general.button.cancel" />
      </Button>
    </>
  )
}
